import React, { PureComponent } from 'react';
import T from 'prop-types';
import Peaks from '../peaks';

const WAVEFORM_BASE_COLOR = '#a1a4aa';
const WAVEFORM_PRGORESS_COLOR = '#46c9dc';
const WAVEFORM_HEIGHT = 84;

export default class Canvas extends PureComponent {
  componentDidMount() {
    this.waveformCanvas = document.createElement('canvas');
    this.drawWaveform();
    this.drawCanvas();
  }

  componentDidUpdate(prevProps) {
    const hasNewWidth = prevProps.width !== this.props.width;
    const hasNewPeaks = prevProps.peaks !== this.props.peaks;
    if (hasNewWidth || hasNewPeaks) {
      this.drawWaveform();
    }

    this.drawCanvas();
  }

  drawWaveform() {
    const { peaks, width } = this.props;
    const halfHeight = Math.round(WAVEFORM_HEIGHT * 0.5);

    this.waveformCanvas.width = width;
    this.waveformCanvas.height = WAVEFORM_HEIGHT;
    const ctx = this.waveformCanvas.getContext('2d');

    ctx.clearRect(0, 0, width, WAVEFORM_HEIGHT);
    ctx.beginPath();
    peaks.getSamples(width).forEach((peak, x) => {
      ctx.moveTo(x, (halfHeight - peak * halfHeight + 0.5) << 0);
      ctx.lineTo(x, (halfHeight + peak * halfHeight + 0.5) << 0);
    });
    ctx.stroke();
  }

  drawCanvas() {
    if (!this.canvas) {
      return;
    }

    const ctx = this.canvas.getContext('2d');
    ctx.clearRect(0, 0, this.props.width, WAVEFORM_HEIGHT);

    ctx.fillStyle = WAVEFORM_BASE_COLOR;
    ctx.fillRect(0, 0, this.props.width, WAVEFORM_HEIGHT);

    ctx.fillStyle = WAVEFORM_PRGORESS_COLOR;
    ctx.fillRect(0, 0, this.props.progress * this.props.width, WAVEFORM_HEIGHT);

    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(this.waveformCanvas, 0, 0);

    ctx.globalCompositeOperation = 'source-over';
  }

  setRef = canvas => {
    this.canvas = canvas;
  };

  render() {
    return <canvas ref={this.setRef} width={this.props.width} height={WAVEFORM_HEIGHT} />;
  }
}

Canvas.propTypes = {
  peaks: T.instanceOf(Peaks),
  width: T.number.isRequired,
  progress: T.number.isRequired,
};
